import React from 'react';

const ReactSvgIcon = ({ icon, iconClass }) => {
  const right = { display: 'inline', textAlign: 'right' }

  return (
    <div>
      <div style={right}>
        <img
          src={icon}
          alt={iconClass}
          className={iconClass}
        />
      </div>
    </div>
  );
}

export default ReactSvgIcon;